import {CalculadoraPrecoSabor} from "./SaborPizzaLoja";
import {ObjetoComAdicionais} from "./ObjetoComAdicionais";

const PESO = 'Peso'

export class ItemPedido extends ObjetoComAdicionais {
  total: number;
  valorUnitario: number;
  valorResgatado: number;
  adicionais: any;
  produtoTamanho: any;
  sabores = [];
  guid: string;
  qtdeSabores: number;
  brinde: any;
  opcoes: any[] = [];

  constructor(public produto: any, public qtde: number,
              public observacao: string) {
    super();
    this.adicionais = {}
    this.valorUnitario = produto?.preco || 0;
    if(produto && produto.brinde)
      this.brinde = true;
    try{
      this.guid =  (crypto as any).randomUUID();
    } catch (e) {
      this.guid = new Date().getTime().toString()
    }
    this.atualizeTotal();
  }

  atualize(qtde, observacao: string, adicionais: any, tamanho: any , sabores: any){
    this.qtde = qtde;
    this.produtoTamanho = tamanho;
    this.sabores = sabores || [];

    this.observacao = observacao

    this.adicionais = adicionais
    this.atualizeTotal()
  }


  atualizeTotal() {
    if(this.produto && this.brinde){
      this.valorUnitario = 0;
      this.total = 0;
      this.valorResgatado = this.produto.valorResgate * this.qtde;
    } else {
      this.valorUnitario = this.obtenhaValorUnitario();
      this.total = this.obtenhaValor();
    }
  }

  obtenhaValor(): number {
    const detalhesAdicionais = this.obtenhaDetalhesValorAdicionais();
    const valorBase = this.obtenhaPreco();

    if(this.produto.tipoDeVenda  && this.produto.tipoDeVenda === PESO)
      return this.obtenhaValorPorPeso();

    return Number(((valorBase * this.qtde) + (detalhesAdicionais.multiplicados * this.qtde) + detalhesAdicionais.independentes).toFixed(2));
  }

  obtenhaValorUnitario(): number {
    if(this.produto.tipoDeVenda  && this.produto.tipoDeVenda === PESO)
      return this.obtenhaValorPorPeso();

    const detalhesAdicionais = this.obtenhaDetalhesValorAdicionais();

    return Number((this.obtenhaPreco() + detalhesAdicionais.multiplicados).toFixed(2));
  }

  obtenhaPontosFidelidade(atividade: any){
    if(atividade.cashback != null){//ativiade que determina sera chashback ou pontos
      let preco = this.total, cashback = atividade.cashback;

      if(this.produtoTamanho && this.produtoTamanho.template){
        if(this.produtoTamanho.template.cashback != null)
          cashback = (this.produtoTamanho.template.cashback / 100)
      } else  if(this.produto.cashback != null){
        cashback = (this.produto.cashback / 100)
      }

      let pontos = cashback  * preco;

      return Number(pontos.toFixed(2))
    }

    let pontosPorProduto =    ( atividade.pontosGanhos || 0);

    if(this.produtoTamanho && this.produtoTamanho.template ){
      if(this.produtoTamanho.template.pontosGanhos != null)
        pontosPorProduto = this.produtoTamanho.template.pontosGanhos
    } else if(this.produto.pontosGanhos != null)
      pontosPorProduto = this.produto.pontosGanhos

    return pontosPorProduto * this.qtde;
  }

  private obtenhaPreco(){
    if(this.sabores && this.sabores.length)
       return  CalculadoraPrecoSabor.calculeValorSabores(this.produto.template, this.sabores);

    if(this.produtoTamanho)
      return this.produtoTamanho.preco;

    if(this.produto.novoPreco) return this.produto.novoPreco;

    return this.produto.preco;
  }

  private podeMultiplicarQuantidadeDoProduto(meta: any): boolean {
    return meta?.multiplicaQuantidadeProduto !== false;
  }

  private obtenhaDetalhesValorAdicionais(): { multiplicados: number; independentes: number; total: number } {
    let multiplicados = 0;
    let independentes = 0;

    for (let prop in this.adicionais) {
      if(prop.startsWith('meta_')) continue;

      if(prop.startsWith('campo') && this.adicionais[prop] != null) {
        const meta = this.adicionais['meta_' + prop];
        const valor = Number(this.adicionais[prop].valor || 0);

        if(this.podeMultiplicarQuantidadeDoProduto(meta))
          multiplicados += valor;
        else
          independentes += valor;
      }
      else if(prop.startsWith('lista')) {
        let opcoes = this.adicionais[prop]
        let valorBase = this.obtenhaValorAdicional(opcoes)

        if(this.podeMultiplicarQuantidadeDoProduto(opcoes))
          multiplicados += valorBase
        else
          independentes += valorBase
      }
    }

    return {
      multiplicados: Number(multiplicados.toFixed(2)),
      independentes: Number(independentes.toFixed(2)),
      total: Number((multiplicados + independentes).toFixed(2))
    };
  }

  obtenhaValorAdicionais() {
    return this.obtenhaDetalhesValorAdicionais().total;
  }

  obtenhaValorPorPeso(): number{
    let qtdePorPeso = this.qtde;

    if(this.produto.unidadeMedida && this.produto.unidadeMedida.sigla === 'g'  )
       qtdePorPeso = this.qtde / 1000;

    let valorDoPeso = Number((this.obtenhaPreco() * qtdePorPeso ).toFixed(2));

    //quando for por peso adicionais e calculado a parte
    return Number((valorDoPeso + this.obtenhaValorAdicionais()).toFixed(2));
  }

  obtenhaDescricao(){
    let descricao = this.produto.nome;

    if(this.produtoTamanho){
      descricao = String(`${this.produto.nome} ${this.produtoTamanho.descricao}`);

      if(this.sabores && this.sabores.length){
        let listaSabores = this.sabores.map( (sabor: any) => sabor.nome);

        if(listaSabores.length   === 1)
          descricao = String(`${this.produto.template.identificador} ${this.produtoTamanho.descricao}  - ${listaSabores[0]}`);
        else{
          for(let i = 0 ; i < listaSabores.length; i++){
            listaSabores[i] = String(`${(i + 1)}°: ${listaSabores[i]}`)
          }
          descricao = String(`${this.produto.template.identificador} ${this.produtoTamanho.descricao} ${this.sabores.length} Sabores ( ${listaSabores.join('; ') } )`);
        }


      }
    }

    return descricao;
  }

  obtenhaUnidade(){
    if(this.produto.tipoDeVenda && this.produto.tipoDeVenda === PESO)
      return this.produto.unidadeMedida.sigla.toLowerCase() + " de ";

    return 'x'
  }

  temOpcaoSelecionada(campo: any, opcao: any): boolean {
    if (!this.opcoes) {
      return false;
    }
    
    return this.opcoes.some(op => 
      op.campoAdicional && op.campoAdicional.id === campo.id && 
      op.opcao && op.opcao.id === opcao.id
    );
  }
}
